import { render, staticRenderFns } from "./CloneElementsFromCardModal.vue?vue&type=template&id=7513b0b1"
import script from "./CloneElementsFromCardModal.vue?vue&type=script&lang=js"
export * from "./CloneElementsFromCardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports